import {
  subscribe,
  broadcast,
  TEventSubscribeHandler,
  TEventUnsubscribeHandler,
} from '@gem/modules/eventBus';

function getBusStation(): string {
  return 'start-reply-message';
}

export const subscribeStartReplyMessage = (
  callback: TEventSubscribeHandler
): TEventUnsubscribeHandler => {
  return subscribe(getBusStation(), callback);
};

export const broadcastStartReplyMessage = (): void => {
  broadcast(getBusStation());
};
